<template>
  <v-dialog :modelValue="dialog" @click:outside="$emit('close')" @keydown.esc="$emit('close')" max-width="1100px" transition="dialog-bottom-transition">
    <v-card>
      <v-form>

          <v-card-title>
            <span class="headline">Agregar ubicación de picking</span>
          </v-card-title>

          <v-card-text>
            <v-card class="mb-4">
              <div class="row mb-2 ps-3 pe-3 mt-0 mb-2">
                <div class="col-md-12">
                  <div class="col-md-12" style="background: white">
                    <p class="text-h6 mt-2 mb-0"><font-awesome-icon icon="filter" class="pr-2" />Filtros</p>
                    <v-divider class="mt-0"></v-divider>
                    <div class="row pt-2">
                      <div class="col-md-3">
                        <v-combobox
                          density="comfortable"
                          v-model="filters.almacen"
                          item-title="label"
                          item-value="id"
                          :items="almacenes"
                          label="Almacen"
                          autocomplete="off"
                          clearable
                          :loading="loading_almacenes"
                          :disabled="almacen != null"
                          :hint="almacen != null ? 'Fijado por el almacén de la regla' : ''"
                          persistent-hint
                          @update:modelValue="loadZonas(); loadTiposUbicacion();"
                        ></v-combobox>
                      </div>
                      <div class="col-md-3">
                        <v-combobox
                          density="comfortable"
                          v-model="filters.zona"
                          item-title="label"
                          item-value="id"
                          :items="zonas"
                          label="Zona"
                          autocomplete="off"
                          clearable
                          :loading="loading_zonas"
                        ></v-combobox>
                      </div>
                      <div class="col-md-3">
                        <v-combobox
                          density="comfortable"
                          v-model="filters.tipo_ubicacion"
                          item-title="name"
                          item-value="id"
                          :items="tipos_ubicaciones"
                          label="Tipo de ubicación"
                          autocomplete="off"
                          clearable
                          :loading="loading_tipos_ubicaciones"
                        ></v-combobox>
                      </div>
                      <div class="col-md-3">
                        <v-combobox density="comfortable" v-model="filters.status" item-title="name" item-value="id" :items="states" label="Estado" autocomplete="off" clearable></v-combobox>
                      </div>
                      <div class="col-md-3">
                        <v-text-field v-model="filters.code" density="comfortable" label="Codigo" @keyup.enter="filter"></v-text-field>
                      </div>
                      <div class="col-md-3">
                        <v-text-field v-model="filters.rack" density="comfortable" label="Rack" @keyup.enter="filter"></v-text-field>
                      </div>
                      <div class="col-md-3">
                        <v-text-field v-model="filters.col" density="comfortable" label="Columna" @keyup.enter="filter"></v-text-field>
                      </div>
                      <div class="col-md-3">
                        <v-text-field v-model="filters.level" density="comfortable" label="Nivel" @keyup.enter="filter"></v-text-field>
                      </div>
                      <div class="col-md-12 mt-2 mb-2" style="display: flex; justify-content: end">
                        <v-btn color="info" @click="filter" prepend-icon="mdi-magnify">Buscar</v-btn>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-card>

            <v-data-table :headers="headers" :items="available_list" :loading="loading" loading-text="Cargando..." :items-per-page="10" no-data-text="No hay ubicaciones de picking para esos filtros">
              <template v-slot:headers>
                <tr>
                  <th class="text-center" style="width: 48px">
                    <v-checkbox
                      :model-value="all_selected"
                      :indeterminate="some_selected && !all_selected"
                      :disabled="available_list.length == 0"
                      hide-details
                      density="compact"
                      @update:model-value="toggleAll"
                    ></v-checkbox>
                  </th>
                  <th class="text-left">Almacen</th>
                  <th class="text-left">Zona</th>
                  <th class="text-left">Tipo</th>
                  <th class="text-left">Codigo</th>
                  <th class="text-left">Rack</th>
                  <th class="text-left">Columna</th>
                  <th class="text-left">Nivel</th>
                  <th class="text-left">Estado</th>
                </tr>
              </template>
              <template v-slot:item="{ item }">
                <tr>
                  <td class="text-center">
                    <v-checkbox v-model="selected" :value="item.id" hide-details density="compact"></v-checkbox>
                  </td>
                  <td>{{ item.zona && item.zona.almacen ? item.zona.almacen.code : "-" }}</td>
                  <td>{{ item.zona ? item.zona.name : "-" }}</td>
                  <td>{{ item.tipo_ubicacion ? item.tipo_ubicacion.name : "-" }}</td>
                  <td>{{ item.code }}</td>
                  <td>{{ item.rack }}</td>
                  <td>{{ item.col }}</td>
                  <td>{{ item.level }}</td>
                  <td>{{ item.status ? item.status.name : "-" }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('close')">Cerrar</v-btn>
            <v-btn color="success" text :disabled="selected.length == 0" @click="addSelected">Agregar ({{ selected.length }})</v-btn>
          </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { ubicacionService } from "@/libs/ws/ubicacionService";
import { almacenService } from "@/libs/ws/almacenService";
import { zonaService } from "@/libs/ws/zonaService";
import { tipoUbicacionService } from "@/libs/ws/tipoUbicacionService";

export default {
  props: {
    dialog: Boolean,
    //Ids ya cargados en la regla: no se vuelven a ofrecer
    excluded_ids: {
      type: Array,
      default: () => [],
    },
    //Almacen de la regla: fuerza el filtro asi no se mezclan ubicaciones de distintos almacenes
    almacen: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      loading_almacenes: false,
      loading_zonas: false,
      loading_tipos_ubicaciones: false,
      list: [],
      selected: [],//ids de ubicaciones tildadas en la tabla
      almacenes: [],
      zonas: [],
      tipos_ubicaciones: [],
      states: [],
      filters: {
        zona: null,
        tipo_ubicacion: null,
        almacen: null,
        status: null,
        rack: null,
        col: null,
        level: null,
        code: null,
      },
      headers: [
        { title: "", key: "select", sortable: false, align: "center", width: 48 },
        { title: "Almacen", key: "almacen", sortable: false },
        { title: "Zona", key: "zona", sortable: false },
        { title: "Tipo", key: "tipo_ubicacion", sortable: false },
        { title: "Codigo", key: "code", sortable: false },
        { title: "Rack", key: "rack", sortable: false },
        { title: "Columna", key: "col", sortable: false },
        { title: "Nivel", key: "level", sortable: false },
        { title: "Estado", key: "status", sortable: false },
      ],
    };
  },
  computed: {
    available_list() {
      return this.list.filter((item) => !this.excluded_ids.includes(item.id));
    },
    all_selected() {
      return this.available_list.length > 0 && this.selected.length === this.available_list.length;
    },
    some_selected() {
      return this.selected.length > 0;
    },
  },
  watch: {
    dialog(value) {
      if (value) {
        //Cada vez que se abre el modal arranca sin tildes: sino podrian arrastrarse de una apertura anterior
        this.selected = [];

        //Si la regla ya fijo un almacen, mando ese; sino, el que tenga guardado en localStorage
        if (this.almacen != null) {
          this.filters.almacen = this.almacen;
        } else if (this.filters.almacen == null) {
          this.filters.almacen = JSON.parse(localStorage.getItem("almacen"));
        }
        this.loadZonas();
        this.loadTiposUbicacion();
        this.filter();
      }
    },
  },
  mounted() {
    this.loadStates();
    this.loadAlmacenes();
    if (this.almacen != null) {
      this.filters.almacen = this.almacen;
    } else {
      this.filters.almacen = JSON.parse(localStorage.getItem("almacen"));
    }
  },
  methods: {
    loadStates() {
      ubicacionService
        .getStates()
        .then((response) => {
          this.states = response.result;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadAlmacenes() {
      this.loading_almacenes = true;
      almacenService
        .filter()
        .then((response) => {
          this.almacenes = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        })
        .finally(() => {
          this.loading_almacenes = false;
        });
    },
    loadZonas() {
      this.loading_zonas = true;
      zonaService
        .filter({ almacen: this.filters.almacen })
        .then((response) => {
          this.zonas = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        })
        .finally(() => {
          this.loading_zonas = false;
        });
    },
    loadTiposUbicacion() {
      this.loading_tipos_ubicaciones = true;
      tipoUbicacionService
        .filter({ sucursal: this.filters.almacen ? this.filters.almacen.sucursal : null })
        .then((response) => {
          //Solo tipos de picking: el listado ya fuerza allow_picking, otro tipo nunca traeria resultados
          this.tipos_ubicaciones = response.result.list.filter((tipo) => tipo.allow_picking);
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        })
        .finally(() => {
          this.loading_tipos_ubicaciones = false;
        });
    },
    filter() {
      this.loading = true;

      //allow_picking forzado: una regla de reposicion solo puede apuntar a huecos de picking
      const param = Object.assign({}, this.filters, { allow_picking: 1, limit: 100 });

      ubicacionService
        .filter(param)
        .then((response) => {
          this.list = response.result.list;
        })
        .catch((e) => {
          console.log("service.filter error");
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toggleAll(value) {
      this.selected = value ? this.available_list.map((item) => item.id) : [];
    },
    addSelected() {
      const items = this.available_list.filter((item) => this.selected.includes(item.id));
      this.$emit("select", items);
      this.selected = [];
    },
  },
};
</script>
